import React from 'react';
import { default as BaseNewsTable } from '../../Interest/Table/News/NewsTable';
import { useGetPropertiesNews } from '../../../Hook/Interest/FetchTableData/UseGetNews';
import InterestUri from '../../../Enum/InterestUri';

const NewsTable: React.FC = () => (
    <BaseNewsTable useHook={useGetPropertiesNews} section={InterestUri.PropertiesNews} />
);

export default NewsTable;
